import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import Grid from '@material-ui/core/Grid';
import ReactJWPlayer from 'react-jw-player';
import { Router } from '/routes';
import { isMobile } from "react-device-detect";

// import css from "/static/css/style.css"
// import scssStyles from '/static/css/style.scss'
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import PropTypes from "prop-types";
import {c} from '/utils/log';
import {
    onReady,
    onUnmute,
    doUnMute,
    onPlay,
    onAutoStart,
    onVideoLoad,
    onThreeSeconds,
    onTenSeconds,
    onThirtySeconds,
    onTwentyFivePercent,
    onFiftyPercent,
    onSeventyFivePercent,
    onNinetyFivePercent,
    onOneHundredPercent,
} from '/components/PlayerEventTracking/EventsJwplayer';
import UnmuteButtonText from '/components/unmuteButtonText';

const localStyles = theme => ({
      overlay: {
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.3)',
        zIndex: -1
      },
      videoPlaceholder:{
        width: '100%',
        height: 411,
        zIndex: 2,
        position: 'relative',
        background: 'rgba(0, 0, 0, 0.5)',
        [theme.breakpoints.only('xs')]: {
            height: 'calc(100vw * 0.5625)',
            // height: 202,
        },
      },
    btnLabel: isMobile ? {
        display: 'flex',
        backgroundColor: '#fff',
        maxWidth: '142px',
        borderRadius: '4px',
        padding: '4px 0',
        position: 'absolute',
        top: '16px',
        left: '16px',       
    } : {
        display: 'flex'
    },
    btnRoot: isMobile ? {
        position:'absolute',
        color: '#000',
        zIndex:999,
        top: '0',
        left: '0',
        backgroundColor: 'rgba(0,0,0,0.1)',
        width: '100%',
        height: '100%',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    } : {
        position:'absolute',
        top:'14px',
        left: '14px',
        color: '#000',
        backgroundColor:'#fff',
        zIndex:999,
    },    
    //   playerStyle: {
    //       width: 'inherit',
    //       height: 'inherit',
    //     //   position: 'inherit',
    //     //   bottom: 20
    //   }
})

class VideoDetailPlayer extends Component {
    constructor(props) {
        super(props);
        this.doCountDown = this.doCountDown.bind(this);
        this.onVideoEnds = this.onVideoEnds.bind(this);
    }

    onVideoEnds() {
        c.log('onVideEnds')
        // window.dataLayer = window.dataLayer || [];
        // window.dataLayer.push({
        //     event: 'jwPlayerOneHundredPercentWatched',
        //     eventCategory: 'video',
        //     eventAction: 'end',
        //     eventLabel: this.props.video && this.props.video.title ? this.props.video.title : 'No Title',
        //     jwplayerWidgetPage: this.props.pagePath,
        //     jwplayerWidgetTitle: this.props.video && this.props.video.title ? this.props.video.title : 'No Title',
        // });
        onOneHundredPercent(this.props.video, this.props.pagePath);

        const { upNext, isPlayListURL, playlist, playlistPos } = this.props;
        // let playlistIndex = playlist.videos.filter((item, i) => playlistPos < i  )
        const nextPlayListVideo = playlist && playlist.video_count != playlistPos ? playlist.videos[playlistPos] : null;
        // c.log(nextPlayListVideo)

        if(isPlayListURL) {
            if(nextPlayListVideo)
                this.doCountDown(nextPlayListVideo, playlist.playlist_id);
        }
        else if(upNext)
                this.doCountDown(upNext, null);
    }

    doCountDown(nextVideo, playlistId) {
        const tvTypeIndex = nextVideo.categories && nextVideo.categories.findIndex((category) => category.type === 'TV')
        const routeName = tvTypeIndex >= 0 ? 'tvDetail' : 'videoDetail';

        const slug = nextVideo.slug;
        const title = nextVideo.title;

        let upnext_wrapper = `<div class='upnext-title-style'><div class='upnext-style'>Up Next</div>${  title }</div>`;
        const countdown_html = `
            <div id="countdown">
                <div id="countdown-number"></div>
                <div class="arrow-right"></div>
                <svg>
                    <circle r="36" cx="40" cy="40"></circle>
                </svg>
            </div>
            <div id="countdown-cancel">
                Cancel
            </div>
        `;
        const countdown_html_mobile = `
            <div id="countdown">
                <div id="countdown-number"></div>
            <svg>
                <circle r="22" cx="25" cy="25"></circle>
            </svg>
            </div>
            <div id="countdown-cancel">
                Cancel
            </div>
        `;

        const countdown_wrapper = document.createElement('div');
        countdown_wrapper.setAttribute("id", "countdown-wrapper");
        countdown_wrapper.innerHTML = isMobile ? upnext_wrapper += countdown_html_mobile : upnext_wrapper += countdown_html;
        const player_overlay = document.getElementById('player-overlay');
        player_overlay.style.zIndex = 2;
        player_overlay.insertBefore(countdown_wrapper, player_overlay.firstChild);
        const countdownNumberEl = document.getElementById('countdown-number');
        let countdown = 5;

        countdownNumberEl.textContent = countdown;
        const myCountDown = setInterval(() => {
        if(countdown == 1)
            redirectNextVideo();
            countdown = (--countdown <= 0) ? 5 : countdown;
            countdownNumberEl.textContent = countdown;
        }, 1000);

        const clearCountdown = function() {
            player_overlay.style.zIndex = -1;
            clearInterval(myCountDown);
            player_overlay.removeChild(countdown_wrapper);
        };
        var redirectNextVideo = function() {
            clearCountdown();
            // Router.pushRoute(routeName, {id : slug} )
            c.log('ppp')
            // c.log( playlist.videos[playlistIndex[1]].slug)
            Router.pushRoute(routeName, playlistId ? {id: slug, list: playlistId} : {id : slug})
        };
        const countdown_ele = document.getElementById("countdown");
        countdown_ele.onclick = redirectNextVideo;

        const countdown_cancel = document.getElementById("countdown-cancel");
        countdown_cancel.onclick = clearCountdown;
    }

    render() {
        const { classes, video, upNext, pagePath } = this.props;
        const playlist = [{
            // file: `https://cdn.jwplayer.com/videos/${video.jw_media_id}-${video.jwplayer_id}.m3u8`,
            file: `${video.video_url}`,
            image: `${video.posters.thumb}`,
            },
        ];
        const showAds = video.no_ads ? false : true;
        const videoAdTag = video.ad_tag ? video.ad_tag : null;
        const emptyAd = {
            tag: ''
        }
        const customAd = {
            client: "googima",
            tag: videoAdTag
        }
        // customProps = object containing properties to be applied directly to the JW Player instance
        let customProps = {
            // ga: {
            //     label: 'mediaid'
            //     // label: this.props.video && this.props.video.title ? this.props.video.title : 'No Title'
            // },
        }
        if ( showAds === true ) {
            if ( videoAdTag != null )
                customProps.advertising = customAd;
        }
        else {
            customProps.advertising = emptyAd;
        }
        // customProps.floating = true;
        return (
            // <div style={{position:'relative'}} className={css.example}>
          <div className={classes.videoPlaceholder}>
            <Button
              classes={{root: classes.btnRoot, label: classes.btnLabel}}
              variant="contained"
              id="unmute-button"
              style={{ display: window.PlayerUnMuted ? 'none': window.IsAutoPlaySupported ? 'inline' : 'none'}}
              onClick={(e)=>doUnMute(video.jwplayer_id,e)}
            >
              <UnmuteButtonText />
              </Button>
            <div id="player-overlay" className={classes.overlay}>
              {/* <style jsx>{scssStyles}</style> */}
            </div>

            <ReactJWPlayer
              playerId={`${video.jwplayer_id}`}
              playerScript={`https://cdn.jwplayer.com/libraries/${video.jwplayer_id}.js`}
              playlist={playlist}
              isAutoPlay
              renderCaptionsNatively={false}
              isMuted={!window.PlayerUnMuted}
              onUnmute={onUnmute}
              onReady={onReady}
              onPlay={() => onPlay(video,pagePath)}
              //onPause={this.onPause}
              //onTime={this.onTime}
              onAutoStart={() => onAutoStart(video, pagePath)}
              onVideoLoad={() => onVideoLoad(video, pagePath)}
              onThreeSeconds={() => onThreeSeconds(video, pagePath)}
              onTenSeconds={() => onTenSeconds(video, pagePath)}
              onThirtySeconds={() => onThirtySeconds(video, pagePath)}
              onTwentyFivePercent={() => onTwentyFivePercent(video, pagePath)}
              onFiftyPercent={() => onFiftyPercent(video, pagePath)}
              onSeventyFivePercent={() => onSeventyFivePercent(video, pagePath)}
              onNinetyFivePercent={() => onNinetyFivePercent(video, pagePath)}
              onOneHundredPercent={this.onVideoEnds}
              customProps={customProps}
            //   customProps={
            //             { ga: {} },
            //             showAds === true && videoAdTag != null ? { advertising: customAd } :
            //             showAds === true ? {} : // global ads
            //             { advertising: emptyAd }
            //         }
            />
          </div>
        );
    }

    componentDidMount(){
        window.videoDetailCardFloated = true;
        // if(  document.getElementById("videoCard") && document.getElementById('content')){
        //     let header = document.getElementById("videoCard")
        //     let space = document.getElementById("forSpace")
        //     let content = document.getElementById('content')
        //     let sticky =  document.getElementById("videoCard") ? header.offsetTop : null;
        //     function myFunction() {
        //         if (window.pageYOffset > sticky) {
        //             // header.classList.add("sticky");
        //             space.classList.add("spaceHeight");
        //         }

        //     }
        //     window.onscroll = function() {myFunction()};
        // }
    }
    componentWillUnmount() {
        window.videoDetailCardFloated = false;
    }
}

VideoDetailPlayer.propTypes = {
    onThreeSeconds: PropTypes.func,
};

const noOp = () => {};

const defaultProps = {
    onThreeSeconds: noOp,
    onTenSeconds: noOp,
    onThirtySeconds: noOp,
    onTwentyFivePercent: noOp,
    onFiftyPercent: noOp,
    onSeventyFivePercent: noOp,
    onNinetyFivePercent: noOp
}

VideoDetailPlayer.defaultProps = defaultProps;

export default withStyles(localStyles)(VideoDetailPlayer);



